// src/utils/navigation/appScroll.js
/**
 * The app renders every route inside one persistent scroll container in `App`.
 * React swaps the page *inside* it but never unmounts the element, so the
 * browser keeps its `scrollTop` — anything that replaces the visible content
 * without changing the route (a multi-step form advancing, say) has to reset it
 * explicitly, the same way a route change does.
 *
 * Addressed by id rather than a ref so callers deep in the tree can reach it
 * without threading a ref through every intermediate component.
 */

export const APP_SCROLL_CONTAINER_ID = "app-scroll-container";

/**
 * Scrolls the app's routed-content container back to the top.
 *
 * @returns {void}
 */
export function scrollAppContentToTop() {
  if (typeof document === "undefined") return;

  const container = document.getElementById(APP_SCROLL_CONTAINER_ID);
  if (!container) return;

  // scrollTo is absent in jsdom; assigning works in both.
  container.scrollTop = 0;
  container.scrollLeft = 0;
}
